/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface BulkCreateBatchDto {
  /**
   * Number of devices to create
   * @minimum 1
   */
  quantity: number;
  /** Unique batch identifier */
  batchNumber: string;
  /** Device model UUID */
  deviceModelId: string;
}
